<template>
	<div>
		<div class="list-btn">
			<Button type="primary" @click="ret">返回</Button>
		</div>
		<div class="content">

			<Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="120">
				<FormItem label="姓名" prop="name" class="sj">
					<Input v-model="formValidate.name" placeholder="请输入名称"></Input>
				</FormItem>
				<FormItem label="联系方式" prop="phone" class="sj">
					<Input v-model="formValidate.phone" placeholder="请输入备注"></Input>
				</FormItem>
				<FormItem label="区划"  class="sj">
					<Input v-model="formValidate.region.mergerName" placeholder="请输入备注" disabled="disabled"></Input>
				</FormItem>
				<FormItem label="家庭住址" prop="address" class="sj">
					<Input v-model="formValidate.address" placeholder="请输入备注"></Input>
				</FormItem>
				<FormItem label="状态" prop="state" class="sj">
					<Select v-model="formValidate.state" placeholder="请选择状态">
						<Option value="true">启用</Option>
						<Option value="false">禁用</Option>
					</Select>
				</FormItem>
				<FormItem>
					<Button type="primary" @click="handleSubmit('formValidate')">提交</Button>
					<Button @click="handleReset('formValidate')" style="margin-left: 8px">清空</Button>
				</FormItem>
			</Form>

		</div>
	</div>
</template>

<script>
	import http from '@/http/http.js'
	export default {
		data() {
			return {
				formValidate: {
					id:'',
					name: '',
					phone: '',
					address: '',
					state: 'true'
				},
				ruleValidate: {
					name: [{
						required: true,
						message: '姓名不能为空！！！',
						trigger: 'blur'
					}],
					phone: [{
						required: true,
						message: '联系方式不能为空！！！',
						trigger: 'blur'
					}],
					address: [{
						required: true,
						message: '家庭住址不能为空！！！',
						trigger: 'blur'
					}],
					state: [{
						required: true,
						message: '状态不能为空！！！',
						trigger: 'blur'
					}]

				}

			}
		},
		methods: {
			ret() { //返回上一页
				this.$router.go(-1)
			},
			handleSubmit(name) {
				let _this=this
				this.$refs[name].validate((valid) => {
					this.formValidate.createdTime=''
					if (valid) {
						http.http({
						    //这里是你自己的请求方式、url和data参数
						    method: 'post',
						    url: http.url + '/plat/jm/emp/update/superior',
						    data: _this.formValidate,
							_this: _this,
							success: function(data) {
								_this.$Message.success('修改成功!');
							}
						    //假设后台需要的是表单数据这里你就可以更改
						  })
						

					} else {
						this.$Message.error('请完善信息后再进行提交!');
					}
				})
			},
			handleReset(name) {
				this.$refs[name].resetFields();
			}
		},
		created() {
			let id=this.$route.query.id
			this.formValidate.id=id
			let _this=this
			http.http({
			    //这里是你自己的请求方式、url和data参数
			    method: 'post',
			    url: http.url + '/plat/jm/emp/get',
			    data: {id:id},
				_this: _this,
				success: function(data) {
					_this.formValidate=data.emp
					_this.formValidate.state+=""
				}
			    //假设后台需要的是表单数据这里你就可以更改
			  })
			
		}
	}
</script>

<style scoped="scoped">
	.list-btn {
		margin-bottom: 20px;
	}

	.sj {
		width: 400px !important;
	}

	.content {
		margin-left: 20%;

	}

	.content .nr {
		margin-top: 20px;
	}
</style>



// WEBPACK FOOTER //
// src/components/jm/admin/emp/update.vue